import { useQuery } from "react-query";
import { fetchMarketSection } from "./fetchMarketSection";

const useTopSellingLimit = () => {
  const { data, isLoading, isError } = useQuery("topsellingLimit", async () => {
    const result = await fetchMarketSection(
      `${process.env.REACT_APP_SERVER_URL}/product/category/hot-deals`
    );
    return result || { hotDealProducts: [] };
  });

  return { data, isLoading, isError };
};

export default useTopSellingLimit;
